import { render } from "./InoutTab.vue?vue&type=template&id=14a98b11&scoped=true"
import script from "./InoutTab.vue?vue&type=script&lang=js"
export * from "./InoutTab.vue?vue&type=script&lang=js"

import "./InoutTab.vue?vue&type=style&index=0&id=14a98b11&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a98b11"]])

export default __exports__